


export default function LoadingAgreements() {
  <div className="bg-primary-50 w-full md:w-1/2 min-w-[233px] rounded-lg shadow-md px-[2rem] py-[1rem] min-h-[10rem] animate-pulse" >
    <div className="pb-[1rem] h-[46px] max-w-[463px] bg-gray-200" />
    <div className="flex flex-row">
      <div className="flex items-center aspect-square justify-center h-[4.7rem] w-[4.7rem] rounded-full bg-primary-500">
        <div          
          className="bg-gray-200 rounded-full w-[28px] h-[37px]"
        />
      </div>
      <div className="flex flex-col pl-[1rem]">
        <div className="max-w-[360px] h-[24px] bg-gray-200"></div>
        <div className="max-w-[200px] h-[24px] bg-gray-200"></div>
        <div className="max-w-[200px] h-[20px] bg-gray-200"></div>
      </div>
    </div>
  </div>;
}
